var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSecurityOn = function SvgSecurityOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.28 9.53a.75.75 0 0 0-1.06-1.06l-4.72 4.72-1.72-1.72a.75.75 0 0 0-1.06 1.06l1.72 1.72a1.5 1.5 0 0 0 2.12 0l4.72-4.72Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.592 1.633a2.25 2.25 0 0 0-1.184 0l-6.75 1.841A2.25 2.25 0 0 0 3 5.645v10.031c0 .77.393 1.485 1.042 1.898l6.75 4.296a2.25 2.25 0 0 0 2.416 0l6.75-4.296A2.25 2.25 0 0 0 21 15.676V5.646a2.25 2.25 0 0 0-1.658-2.172l-6.75-1.84Zm-.79 1.448a.75.75 0 0 1 .395 0l6.75 1.84a.75.75 0 0 1 .553.724v10.031a.75.75 0 0 1-.347.633l-6.75 4.295a.75.75 0 0 1-.806 0l-6.75-4.295a.75.75 0 0 1-.347-.633V5.646a.75.75 0 0 1 .553-.724l6.75-1.841Z"
  })));
};
export default SvgSecurityOn;